<template>
  <v-row>
    <v-col cols="12">
      <Title :titlePage="titlePage" />
    </v-col>

    <v-container>
      <SupplierQualityForm
        :supplierQuality="supplierQuality"
        :supplierQuality_a_articles="supplierQuality_a_articles"
        :mode="mode"
        @emitSupplierQuality="createOrUpdateSupplierQuality"
      />
      <Popup :dialog="dialog" :text="messageCreation" :actions="actions" />
    </v-container>
  </v-row>
</template>

<script>
import Title from "@/components/shared/Title";
import SupplierQualityForm from "@/components/Forms/SupplierQualityForm";
import Popup from "@/components/shared/Popup";
import apiSupplierQuality from "@/api/supplier_quality";

export default {
  components: {
    Title,
    SupplierQualityForm,
    Popup,
  },
  data() {
    return {
      supplierQuality: {
        id: null,
        date: "",
        supplier: "",
        non_compliance_fta_number: "",
        contact: "",
        email: "",
        code_production_comment: "",
        description: "",
        estimated_cost: "",
        estimated_cost_description: "",
        is_accepted: false,
        refusal_reason: "",
        non_compliance_number: "",
        need_return: false,
        delivery_type: "",
        shipping_date: null,
        carrier: "",
        package_detail: "",
        status: "",
      },
      mode: "",
      titlePage: "",
      dialog: false,
      messageCreation: "",
      actions: "supplier_quality",
      yearCount: 0,
      supplierQuality_a_articles: [],
    };
  },
  created() {
    this.initializePage();
  },
  watch: {
    'supplierQuality.supplier': {
      handler(newSupplier, oldSupplier) {
        if (this.mode === 'creation' && newSupplier && newSupplier !== oldSupplier) {
          this.generateNonComplianceNumber();
        }
      },
      deep: false,
    },
  },
  methods: {
    initializePage() {
      const routeName = this.$route.name;
      const id = this.$route.params.id;

      if (routeName === 'view_supplier_quality') {
        this.mode = "visualisation";
        this.titlePage = "Voir Qualité Fournisseur";
        this.getSupplierQuality(id);
      } else if (routeName === 'update_supplier_quality') {
        this.mode = "modification";
        this.titlePage = "Modifier Qualité Fournisseur";
        this.getSupplierQuality(id);
      } else {
        this.mode = "creation";
        this.titlePage = "Créer Qualité Fournisseur";
        this.supplierQuality.date = new Date().toISOString().split('T')[0];
        this.fetchYearCount();
      }
    },
    getSupplierQuality(id) {
      apiSupplierQuality.getSupplierQuality(id).then((res) => {
        console.log("Supplier Quality data:", res.data.supplier_quality);
        this.supplierQuality = {
          ...res.data.supplier_quality,
          date: res.data.supplier_quality.date ? res.data.supplier_quality.date.split('T')[0] : "",
          shipping_date: res.data.supplier_quality.shipping_date ? res.data.supplier_quality.shipping_date.split('T')[0] : null,
        };
        this.supplierQuality_a_articles = res.data.supplier_quality.articles || [];
      }).catch((error) => {
        console.error("Error loading supplier quality:", error);
      });
    },
    createOrUpdateSupplierQuality(supplierQuality) {
      if (this.mode === "modification") {
        this.updateSupplierQuality(supplierQuality);
      } else {
        this.createSupplierQuality(supplierQuality);
      }
    },
    createSupplierQuality(supplierQuality) {
      const payload = {
        ...supplierQuality,
        articles: this.supplierQuality_a_articles,
      };

      apiSupplierQuality
        .createSupplierQuality(payload)
        .then((res) => {
          console.log("Created supplier quality:", res);
          this.messageCreation = "Qualité fournisseur créée avec succès";
          this.dialog = true;
          setTimeout(() => {
            this.$router.push({ name: "supplier_quality" });
          }, 2000);
        })
        .catch((error) => {
          console.error("Error creating supplier quality:", error);
          this.messageCreation = "Erreur lors de la création";
          this.dialog = true;
        });
    },
    updateSupplierQuality(supplierQuality) {
      const payload = {
        ...supplierQuality,
        articles: this.supplierQuality_a_articles,
      };

      apiSupplierQuality
        .updateSupplierQuality(supplierQuality.id, payload)
        .then((res) => {
          console.log("Updated supplier quality:", res);
          this.messageCreation = "Qualité fournisseur modifiée avec succès";
          this.dialog = true;
          setTimeout(() => {
            this.$router.push({ name: "supplier_quality" });
          }, 2000);
        })
        .catch((error) => {
          console.error("Error updating supplier quality:", error);
          this.messageCreation = "Erreur lors de la modification";
          this.dialog = true;
        });
    },
    fetchYearCount() {
      const currentYear = new Date().getFullYear();
      apiSupplierQuality
        .getYearCount(currentYear)
        .then((res) => {
          this.yearCount = res.data.count || 0;
          // Regenerate the number if supplier is already filled
          if (this.mode === 'creation' && this.supplierQuality.supplier) {
            this.generateNonComplianceNumber();
          }
        })
        .catch((error) => {
          console.error("Error fetching year count:", error);
          this.yearCount = 0;
        });
    },
    generateNonComplianceNumber() {
      const currentYear = new Date().getFullYear();
      const supplier = this.supplierQuality.supplier.toUpperCase();
      const sequentialNumber = this.yearCount + 1;
      this.supplierQuality.non_compliance_fta_number = `${currentYear} - ${supplier} - ${sequentialNumber}`;
    },
  },
};
</script>
